import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorIdentification } from '../../../state/vendorSlice';

const DbaEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorIdentification({ dba: event.target.value }));
  };

  return (
    <TextField
      label="DBA (Doing Business As)"
      size="small"
      fullWidth
      value={currentVendor?.dba || ''}
      onChange={handleChange}
    />
  );
};

export default DbaEdit;
